import './instrument'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import './index.css'
import { ThemeProvider } from './theme/ThemeProvider'
import { I18nProvider } from './i18n/I18nProvider'
import { LocaleRouteSync } from './i18n/LocaleRouteSync'
import { SeoLinks } from './components/seo/SeoLinks'

async function enableMocking() {
  // Enable MSW in both development and production
  // This ensures our mock API works everywhere
  
  try {
    const { worker } = await import('./mocks/browser')
    
    // Start the worker with different settings based on environment
    return worker.start({
      // In development, warn about unhandled requests
      // In production, be quiet about them
      onUnhandledRequest: import.meta.env.DEV ? 'warn' : 'bypass',
      // Make service worker quieter in production
      serviceWorker: {
        // Customize the registration options
        options: {
          // This helps with Netlify deployments
          scope: '/',
        },
      },
    })
  } catch (error) {
    console.error('Error starting MSW:', error)
  }
}

enableMocking().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <BrowserRouter>
        <ThemeProvider>
          <I18nProvider>
            <LocaleRouteSync />
            <SeoLinks />
            <App />
          </I18nProvider>
        </ThemeProvider>
      </BrowserRouter>
    </React.StrictMode>,
  )
})
